import React, { useContext, useEffect, useState } from "react";
import "./Login.css";
import axios from "../axios/axios";
import Context from "../../Context/Context";
import { useNavigate } from "react-router-dom";
import NotificacaoDeErro from "../Notificacao/NotificacaDeErro";
import NotificacaoDeSucesso from "../Notificacao/NotificacaoDeSucesso";
import { set } from "date-fns";
import { IoEyeSharp } from "react-icons/io5";
import { FaRegEyeSlash } from "react-icons/fa6";
import { log } from "pdfmake/build/pdfmake";



const Cadastro = () => {
  const [formData, setFormData] = useState({
    email: "",
    nome: "",
    funcao: "",
    cargo: "",
    departamento_id: "4",
    setor_id: "1",
    celula_id: "1",
    senha: "",
    confirmarSenha: "",
    usuario_foto: null, // Adicionado para armazenar o arquivo da imagem
  });
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarConfirmarSenha, setMostrarConfirmarSenha] = useState(false);
  const { usuario } = useContext(Context);
  const [dragOver, setDragOver] = useState(false);
  const [preview, setPreview] = useState(null);

  const navigate = useNavigate();
  const [mostrarNotificacao, setMostrarNotificacao] = useState(false);
  const [mostrarNotificacaoDeSucesso, setMostrarNotificacaoDeSucesso] =
    useState(false);
  let [msn, setMsn] = useState("");

  useEffect(() => {
    if (usuario?.role !== "AdministrativoSupervisor") {
      console.log(usuario);
      navigate("/captacao/home");
    }
  }, [usuario]);
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "usuario_foto") {
      // Armazena o arquivo no estado
      setFormData((prevData) => ({ ...prevData, [name]: files[0] }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.senha !== formData.confirmarSenha) {
      setMsn("As senhas são diferentes");
      setMostrarNotificacao(true);
      return;
    }
    // Cria um objeto FormData
    const data = new FormData();
    data.append("email", formData.email);
    data.append("nome", formData.nome);
    data.append("funcao", formData.funcao);
    data.append("cargo", formData.cargo);
    data.append("departamento_id", formData.departamento_id);
    data.append("setor_id", formData.setor_id);
    data.append("celula_id", formData.celula_id);
    data.append("senha", formData.senha);
    if (formData.usuario_foto) {
      data.append("file", formData.usuario_foto); // Adiciona o arquivo da imagem
    }
    try {
      const response = await axios.post("/user", data, {
        headers: {
          Authorization: usuario.token,
          "Content-Type": "multipart/form-data",
        },
      });
      resetForm();
      setMostrarNotificacaoDeSucesso(true);
    } catch (error) {
      setMsn(error.response?.data?.message || error.message);
      setMostrarNotificacao(true);
    }
  };
  const resetForm = () => {
    setFormData({
      email: "",
      nome: "",
      funcao: "",
      cargo: "",
      departamento_id: "4",
      setor_id: "1",
      celula_id: "1",
      senha: "",
      confirmarSenha: "",
      usuario_foto: null,
    });
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      console.log('file', file);
            //   console.log('preview', preview)
      const fakeEvent = { target: { files: [file], name: "usuario_foto" } };
      handleChange(fakeEvent); // Reaproveita sua lógica

    }

  };

  useEffect(() => {
    if (formData.usuario_foto) {
      const objectUrl = URL.createObjectURL(formData.usuario_foto);
      setPreview(objectUrl);

      // Cleanup: revogar a URL anterior quando mudar ou desmontar
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreview(null);
    }
  }, [formData.usuario_foto]);

  return (
    <div className=" h-[100vh] flex justify-center items-center">
      <div className="w-[50%] m-auto flex rounded-lg gap-10 bg-white shadow-md">
        <div className="bg-black w-40  rounded-l-lg"></div>
        <form onSubmit={handleSubmit} className="  w-[100%] p-10">
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 pb-10 text-left">Cadastro</h2>

          <div className="grid grid-cols-2 gap-6 w-full">
            <div className="relative z-0 w-full mb-5 group">
              <input
                type="text"
                name="nome"
                id="nome"
                value={formData.nome}
                onChange={handleChange}
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 rounded-none border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label
                htmlFor="nome"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Nome
              </label>
            </div>

            <div className="relative z-0 w-full mb-5 group">
              <input
                type="email"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="block py-2.5 px-0 w-full text-sm rounded-none text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
              />
              <label
                htmlFor="email"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Email
              </label>
            </div>
          </div>






          <div className="flex gap-5 w-[100%] ">


            <div className="w-[80%] flex flex-col gap-5">

              <div className="relative z-0 w-full mb-5 group">
                <input
                  type="text"
                  name="funcao"
                  id="funcao"
                  value={formData.funcao}
                  onChange={handleChange}
                  required
                  className="block py-2.5 px-0 w-full rounded-none text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                  placeholder=" "
                />
                <label
                  htmlFor="funcao"
                  className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Função
                </label>
              </div>
              <div className="relative z-0 w-full mb-5 group">
                <input
                  type="text"
                  name="cargo"
                  id="cargo"
                  value={formData.cargo}
                  onChange={handleChange}
                  required
                  className="block py-2.5 px-0 w-full text-sm rounded-none text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                  placeholder=" "
                />
                <label
                  htmlFor="cargo"
                  className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Cargo
                </label>
              </div>
            </div>

            <div className="flex justify-between mb-10 gap-10 w-[80%] m-auto">
  {/* Área de Upload */}
  <div className="w-full">
    <label
      htmlFor="file_input"
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={handleDrop}
      className={`flex flex-col items-center justify-center w-full h-40 border-2 ${
        dragOver ? "border-blue-500 bg-blue-50" : "border-dashed border-gray-300 bg-white"
      } rounded-xl cursor-pointer transition duration-300 hover:border-blue-400 hover:bg-blue-50`}
    >
      <div className="flex flex-col items-center">
        <div className="w-12 h-12 mb-2 rounded-full bg-gray-100 flex items-center justify-center">
          <svg
            className="w-6 h-6 text-gray-500"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <p className="text-sm text-gray-600 font-medium">
          Clique para enviar <span className="text-gray-400 font-normal">ou arraste aqui</span>
        </p>
        <p className="text-xs text-gray-400 mt-1">PNG, JPG, JPEG até 5MB</p>
      </div>
      <input
        id="file_input"
        type="file"
        name="usuario_foto"
        onChange={handleChange}
        className="hidden"
      />
    </label>
  </div>

  {/* Pré-visualização */}
  <div className="w-[35%] flex items-center justify-center bg-white rounded-xl border border-gray-200 min-h-[120px]">
    {preview ? (
      <img
        src={preview}
        alt="Pré-visualização"
        className="rounded-lg max-h-[120px] object-cover"
      />
    ) : (
      <span className="text-sm text-gray-400">Nenhuma imagem selecionada</span>
    )}
  </div>
</div>

          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
            {/* Departamento */}
            <div className="flex flex-col w-full max-w-sm mx-auto relative">
              <label htmlFor="departamento_id" className="text-sm font-medium text-gray-700 mb-1">
                Departamento:
              </label>
              <select
                id="departamento_id"
                name="departamento_id"
                value={formData.departamento_id}
                onChange={handleChange}
                required
                className="block appearance-none py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-gray-400 rounded-none"
              >
                <option value="4">Comercial</option>
                <option value="2">Jurídico</option>
                <option value="3">Estratégico</option>
                <option value="5">Marketing</option>
                <option value="1">Administrativo</option>
                <option value="6">Recuperação ExtraJudicial</option>
                <option value="7">Nenhum</option>
              </select>

              {/* Ícone da seta */}
              <div className="pointer-events-none absolute right-2 top-9 text-gray-400">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>



            {/* Setor */}
            <div className="flex flex-col w-full max-w-sm mx-auto relative">
              <label htmlFor="setor_id" className="text-sm font-medium text-gray-700 mb-1">
                Setor:
              </label>
              <select
                id="setor_id"
                name="setor_id"
                value={formData.setor_id}
                onChange={handleChange}
                required
                className="block appearance-none py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-gray-400 rounded-none"
              >
                <option value="1">Captação</option>
                <option value="2">Negócios</option>
                <option value="3">API</option>
                <option value="4">Controladoria</option>
                <option value="5">Editais</option>
                <option value="6">Encerramentos</option>
                <option value="7">Publicação</option>
                <option value="8">Financeiro</option>
                <option value="9">Departamento Pessoal</option>
                <option value="10">Infraestrutura</option>
                <option value="11">Nenhum</option>
              </select>

              {/* Ícone da seta */}
              <div className="pointer-events-none absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

            {/* Célula */}
            <div className="flex flex-col w-full max-w-sm mx-auto relative">
              <label htmlFor="celula_id" className="text-sm font-medium text-gray-700 mb-1">
                Célula:
              </label>
              <select
                id="celula_id"
                name="celula_id"
                value={formData.celula_id}
                onChange={handleChange}
                required
                className="block appearance-none py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-gray-400 rounded-none"
              >
                <option value="1">Tecnologia</option>
                <option value="2">Prospecção</option>
                <option value="3">Avaliação</option>
                <option value="4">Cadastro</option>
                <option value="5">Atendimento</option>
                <option value="6">Mediata</option>
                <option value="7">Imediata</option>
                <option value="8">Nenhuma</option>
              </select>

              {/* Ícone da seta */}
              <div className="pointer-events-none absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full ">
            {/* Senha */}
            <div className="flex flex-col w-full relative">
              <label htmlFor="senha" className="text-sm font-medium text-gray-700 mb-1">
                Senha:
              </label>
              <div className="relative">
                <input
                  id="senha"
                  type={mostrarSenha ? "text" : "password"}
                  name="senha"
                  value={formData.senha}
                  onChange={handleChange}
                  minLength={8}
                  required
                  className="block w-full appearance-none py-2.5 px-0 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-gray-400 rounded-none pr-20"
                />
                <button
                  type="button"
                  onClick={() => setMostrarSenha((prev) => !prev)}
                  className="absolute right-0 top-2 text-sm hover:underline"
                >
                  {mostrarSenha ?  <IoEyeSharp /> :  <FaRegEyeSlash />}
                </button>
              </div>
            </div>

            {/* Confirmar Senha */}
            <div className="flex flex-col w-full relative">
              <label htmlFor="confirmarSenha" className="text-sm font-medium text-gray-700 mb-1">
                Confirmar Senha:
              </label>
              <div className="relative">
                <input
                  id="confirmarSenha"
                  type={mostrarConfirmarSenha ? "text" : "password"}
                  name="confirmarSenha"
                  value={formData.confirmarSenha}
                  onChange={handleChange}
                  minLength={8}
                  required
                  className="block w-full appearance-none py-2.5 px-0 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-gray-400 rounded-none pr-20"
                />
                <button
                  type="button"
                  onClick={() => setMostrarConfirmarSenha((prev) => !prev)}
                  className="absolute right-0 top-2 text-sm  hover:underline"
                >
                  {mostrarConfirmarSenha ?  <IoEyeSharp /> :  <FaRegEyeSlash />}
                </button>
              </div>
            </div>
          </div>


          <div className="flex float-end">
            <button
              type="submit"
              className="btn-cadastra !bg-black text-white !w-[150px]"
            >
              Cadastrar
            </button>
            <NotificacaoDeErro
              mostrar={mostrarNotificacao}
              onClose={() => setMostrarNotificacao(false)}
              mensagem={`erro: ` + msn}
            />
            <NotificacaoDeSucesso
              mostrar={mostrarNotificacaoDeSucesso}
              onClose={() => setMostrarNotificacaoDeSucesso(false)}
              mensagem={"Usuario cadastrado com sucesso"}
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default Cadastro;
